module.exports = __webpack_public_path__ + "img/appoint.f4403bff.png";